import { Component } from "react";
// 1. Import the specific icons from the Ionicons library
import {
  IoBarChartOutline,
  IoShieldCheckmarkOutline,
  IoCashOutline,
  IoPencilOutline,
  IoLocateOutline,
  IoTrendingUpOutline,
} from "react-icons/io5";
import "../styles/channel_benefits.css";

class ChannelBenefits extends Component {
  render() {
    const title = this.props.title || "What You Gain";
    const subtitle = this.props.subtitle || "Benefits of Partnering with XLP";

    // 2. Swap the string paths for the actual icon components
    const displayBenefits = this.props.benefits || [
      {
        id: 1,
        icon: <IoBarChartOutline size={26} color="#b54a2e" />,
        title: "Growing EdTech Opportunity",
        description:
          "Be part of a rapidly expanding education technology ecosystem.",
      },
      {
        id: 2,
        icon: <IoShieldCheckmarkOutline size={26} color="#b54a2e" />,
        title: "Strong Support System",
        description:
          "Get access to XLP's resources, programmes, and structured learning models.",
      },
      {
        id: 3,
        icon: <IoCashOutline size={26} color="#b54a2e" />,
        title: "Recurring Revenue Streams",
        description:
          "Generate consistent income by delivering XLP programmes through your network.",
      },
      {
        id: 4,
        icon: <IoPencilOutline size={26} color="#b54a2e" />,
        title: "Impactful Education",
        description:
          "Contribute to shaping future-ready learners and innovators.",
      },
      {
        id: 5,
        icon: <IoLocateOutline size={26} color="#b54a2e" />,
        title: "Scalable Learning Model",
        description:
          "Our programmes are designed to scale across schools and institutions.",
      },
      {
        id: 6,
        icon: <IoTrendingUpOutline size={26} color="#b54a2e" />,
        title: "Long-Term Growth Potential",
        description:
          "Grow with XLP as we expand into new schools, regions, and learning communities.",
      },
    ];

    return (
      <section className="benefits-section py-4">
        <div className="container py-lg-3">
          {/* Header Text */}
          <div className="text-center mb-4 text-white">
            <h2 className="display-5 fw-normal mb-2">{title}</h2>
            <p className="fs-5">{subtitle}</p>
          </div>

          {/* The Responsive 3-Column Grid */}
          <div className="row g-4">
            {displayBenefits.map((benefit) => (
              <div className="col-12 col-md-6 col-lg-4" key={benefit.id}>
                {/* The Card */}
                <div className="benefit-card h-100 bg-white rounded-4 p-4 p-lg-3 shadow-sm">
                  {/* 3. Render the icon directly (No more <img> tag needed!) */}
                  <div className="icon-wrapper mb-2">{benefit.icon}</div>

                  {/* Title & Description */}
                  <h4 className="benefit-title text-dark fw-medium mb-3">
                    {benefit.title}
                  </h4>
                  <p className="benefit-desc text-secondary mb-0">
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default ChannelBenefits;
